import type { ReactNode } from 'react';
import { Pencil } from '@retail-ops/panel-shell/fi';

export interface KVPairProps {
  label: string;
  value: ReactNode;
  editable?: boolean;
  onEdit?: () => void;
}

/** Primitive 7 (bonus composable): atomic label-above-value pair. */
export function KVPair({ label, value, editable = false, onEdit }: KVPairProps): JSX.Element {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-2)' }}>
      <span
        style={{
          fontSize: 10,
          textTransform: 'uppercase',
          letterSpacing: '0.4px',
          fontWeight: 600,
          color: 'var(--ink-500)',
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: 13,
          color: 'var(--ink-900)',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--sp-3)',
        }}
      >
        {value}
        {editable && (
          <button
            type="button"
            className="btn btn-link"
            aria-label={`Edit ${label}`}
            onClick={onEdit}
            style={{ padding: 0 }}
          >
            <Pencil size={12} />
          </button>
        )}
      </span>
    </div>
  );
}
